import React from "react";
import { Box, Typography, Divider, Skeleton } from "@mui/material";

const InfoRow = ({ label, value, loading }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: { xs: "flex-start", sm: "center" },
      flexDirection: { xs: "column", sm: "row" },
      py: 1.75,
      gap: { xs: 0.5, sm: 1 },
      "&:not(:last-child)": { borderBottom: "1px solid #f0f4f8" },
    }}
  >
    <Typography
      variant="body2"
      sx={{ color: "#6b7280", minWidth: { sm: 160 }, fontWeight: 500, fontSize: "0.825rem", flexShrink: 0 }}
    >
      {label}
    </Typography>
    {loading ? (
      <Skeleton variant="text" width={160} height={20} sx={{ borderRadius: 1 }} />
    ) : (
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color: "#1a1a2e",
          textAlign: { xs: "left", sm: "right" },
          flex: 1,
          wordBreak: "break-word",
        }}
      >
        {value || "—"}
      </Typography>
    )}
  </Box>
);

export const TestInfoSection = ({ formData, loadingFormData, t }) => (
  <>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
      <Box sx={{ width: 3, height: 22, backgroundColor: "#163666", borderRadius: 2, flexShrink: 0 }} />
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a2e" }}>
        {t.testInformation}
      </Typography>
    </Box>

    <Box
      sx={{
        backgroundColor: "#f8fafc",
        borderRadius: 2,
        border: "1px solid #dfdfdf",
        px: { xs: 2, sm: 3 },
        py: 0.5,
        mb: 4,
      }}
    >
      <InfoRow label={t.orderNumber} value={formData.orderNumber} loading={loadingFormData} />
      <InfoRow label={t.testIdentifier} value={formData.testIdentifier} loading={loadingFormData} />
      <InfoRow
        label={t.testSubstrate}
        value={formData.testSubstrate ? formData.testSubstrate.replace(/^SIBO\s*/i, "") : null}
        loading={loadingFormData}
      />
    </Box>

    <Divider sx={{ mb: 4, borderColor: "#dfdfdf" }} />
  </>
);
